import React from "react";
import PropTypes from "prop-types";
import { ReactComponent as MercadoLogo } from "@/assets/images/mercadoLogo.svg";

function Button1xbet({
  children,
  disabled,
  handleClick,
  isSubmitting,
  type,
  variant,
  mercado,
}) {
  if (variant === "secondary") {
    return (
      <button
        type={type === "submit" ? "submit" : "button"}
        disabled={disabled || isSubmitting}
        onClick={handleClick}
        className="bg-transparent border-none text-blue-500 text-sm underline inline-block disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {children}
      </button>
    );
  }

  return (
    <button
      type={type === "submit" ? "submit" : "button"}
      disabled={disabled || isSubmitting}
      onClick={handleClick}
      className="mt-[20px] w-full h-[40px] py-[5px] px-[10px] rounded-md bg-mercado-primary text-black text-sm font-bold hover:brightness-[0.85] disabled:bg-[#cbcbcb] disabled:text-black disabled:cursor-not-allowed disabled:pointer-events-none flex items-center justify-center gap-3 tracking-widest"
    >
      {mercado && <MercadoLogo className="w-[20px] h-[20px]" />}
      <span>{children}</span>
    </button>
  );
}

Button1xbet.propTypes = {
  children: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  handleClick: PropTypes.func,
  isSubmitting: PropTypes.bool,
  type: PropTypes.string,
  variant: PropTypes.string,
  mercado: PropTypes.bool,
};

export default Button1xbet;
